import WonderType from "@/roc/wonders/base/WonderType";
import WonderKind from "@/roc/wonders/base/WonderKind";
import WonderOwner from "@/roc/wonders/base/WonderOwner";
import Effects from '@/roc/effects/Effects';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import EffectAmount from '@/roc/effects/EffectAmount';
import Synergy from '@/roc/wonders/base/Synergy';
import EraType from '@/roc/era/EraType';

const PalaceOfAachen = {
  id: '29',
  name: 'Palace of Aachen',
  era: EraType.earlyRome,
  icon: 'poa',
  gameId: 'PalaceOfAachen',
  minLevel: 1,
  maxLevel: 30,
  type: WonderType.GREAT_EMPIRE,
  kind: WonderKind.FORTRESS | WonderKind.PALACE,
  kindMultiplier: 1,
  owner: WonderOwner.CAPITAL,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.LIGHT_INFANTRY_HIT_POINT_MOD,
      EffectAmount.asPerLevel([
        2.5,
        3.2,
        3.7,
        4.2,
        4.5,  // 5
        4.9,
        5.2,
        5.4,
        5.7,
        5.9,  // 10
        6.2,
        6.4,
        6.6,
        6.8,
        7,  // 15
        7.1,
        7.3,
        7.5,
        7.6,
        7.8,  // 20
        7.9,
        8.1,
        8.2,
        8.4,
        8.5,  // 25
        8.6,
        8.8,
        8.9,
        9,
        9.1   // 30
      ]),
      '%',
    ),
    new PassiveAura(
      PassiveAuraType.IMPERIAL_GUARD_PRODUCTION_TIME_BONUS,
      EffectAmount.asPerLevel([
        5,
        11.2,
        14.8,
        17.4,
        19.3,  // 5
        21,
        22.3,
        23.6,
        24.9,
        26.2,  // 10
        27.5,
        28.8,
        30.1,
        31.4,
        32.7,  // 15
        34,
        35.3,
        36.6,
        37.9,
        39.2,  // 20
        40.5,
        40.9,
        41.4,
        41.8,
        42.3,  // 25
        42.7,
        43.2,
        43.6,
        44.1,
        44.5
      ]),
      '%',
    ),
  ]),
  synergies: [
    {
      effectIndex: 0,
      mod: Synergy.asFlat(2).withKind(WonderKind.FORTRESS),
      effect: null,
    }
  ],
};

export default PalaceOfAachen;
